export default "__VITE_ASSET__5AEfITMk__"